import { Checkbox } from "@/components/ui/checkbox";
import { ShieldAlert } from "lucide-react";
import { useTr } from "@/lib/tr";

function Group({ g, value, onChange, locked }) {
  const tr = useTr();
  const keys = g.permissions.map((p) => p.key);
  const on = keys.filter((k) => value.includes(k)).length;
  const all = on === keys.length;
  const toggleAll = () => onChange(all ? value.filter((k) => !keys.includes(k)) : [...new Set([...value, ...keys])]);
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className={`rounded-xl border p-4 ${g.sensitive ? "border-amber-700/40 bg-amber-500/5" : "border-slate-800 bg-slate-900/60"}`} data-testid={`perm-group-${g.key}`}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-white">
          {g.sensitive && <ShieldAlert className="h-4 w-4 text-amber-400" />}
          {tr.lang === "en" ? g.label_en : g.label}
          <span className="text-xs font-normal text-slate-500">{on}/{keys.length}</span>
        </div>
        <label className="flex cursor-pointer items-center gap-2 text-xs text-slate-400">
          <Checkbox checked={all} disabled={locked} onCheckedChange={toggleAll} data-testid={`perm-group-all-${g.key}`} />
          {tr("Tout le module", "Whole module")}
        </label>
      </div>
      {g.sensitive && <p className="mt-1 text-[11px] text-amber-300/80">{tr("Sensible — refusé par défaut, accordé uniquement par le Super Admin.", "Sensitive — denied by default, granted only by the Super Admin.")}</p>}
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {g.permissions.map((p) => (
          <label key={p.key} className="flex cursor-pointer items-start gap-2 text-sm text-slate-300">
            <Checkbox checked={value.includes(p.key)} disabled={locked} onCheckedChange={() => toggle(p.key)} data-testid={`perm-${p.key}`} className="mt-0.5" />
            <span>{tr.lang === "en" ? p.label_en : p.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export function PermissionMatrix({ catalog, value, onChange, canSensitive }) {
  if (!catalog) return null;
  return (
    <div className="grid gap-3 lg:grid-cols-2" data-testid="permission-matrix">
      {catalog.groups.map((g) => <Group key={g.key} g={g} value={value} onChange={onChange} locked={g.sensitive && !canSensitive} />)}
    </div>
  );
}
